/**
 * Mobile redirect and leftbar management
 *
 * For mobile devices:
 * - Redirects from root path to obras page with filter
 * - Closes leftbar by default
 */

// Helper function to detect mobile (fallback if jQuery.browser.mobile is not available)
function isMobileDevice() {
  if (
    typeof jQuery !== "undefined" &&
    jQuery.browser &&
    jQuery.browser.mobile !== undefined
  ) {
    return jQuery.browser.mobile;
  }
  // Fallback detection using user agent
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return (
    /android|bb\d+|meego|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      userAgent,
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      userAgent.substr(0, 4),
    )
  );
}

// Function to check if mobile and handle leftbar
function handleMobileLeftbar() {
  const isMobile = isMobileDevice();
  const leftbar = document.querySelector(".leftbar");

  if (isMobile && leftbar && leftbar.classList.contains("open")) {
    leftbar.classList.remove("open");
  }
}

// Function to check if there are filters applied (beyond default nuestra_gestion)
function hasFiltersApplied() {
  const searchString = window.location.search;

  // If there's no search string, no filters are applied
  if (!searchString || searchString.length <= 1) {
    return false;
  }

  // Parse the query string manually to handle Rails nested parameters
  const params = {};
  const searchParams = searchString.substring(1).split("&");

  searchParams.forEach(function (param) {
    const parts = param.split("=");
    if (parts.length === 2) {
      const key = decodeURIComponent(parts[0]);
      const value = decodeURIComponent(parts[1]);

      // Store all filtro parameters
      if (key.startsWith("filtro[")) {
        if (!params[key]) {
          params[key] = [];
        }
        params[key].push(value);
      }
    }
  });

  // Get all filtro parameter keys
  const filtroKeys = Object.keys(params);

  // Check if there are filters beyond just nuestra_gestion=1
  if (filtroKeys.length === 0) {
    return false;
  }

  // If there's only nuestra_gestion=1, consider it as no filters applied
  if (
    filtroKeys.length === 1 &&
    filtroKeys[0] === "filtro[nuestra_gestion]" &&
    params["filtro[nuestra_gestion]"] &&
    params["filtro[nuestra_gestion]"][0] === "1"
  ) {
    return false;
  }

  // If there are other filters or nuestra_gestion has a different value, filters are applied
  return true;
}

// Function to handle hiding filter section on mobile when filters are applied
function handleMobileFilterSection() {
  const isMobile = isMobileDevice();
  const currentPath = window.location.pathname;

  // Only apply to obras index page
  if (isMobile && currentPath === "/obras") {
    const hasFilters = hasFiltersApplied();
    const filterSection = document.getElementById("obra_filter");

    if (hasFilters && filterSection) {
      // Find the collapse element inside the filter section
      // The collapse id is generated from the section id
      const header = filterSection.querySelector(".header_index_collapse");

      if (header) {
        const dataTarget = header.getAttribute("data-target");
        if (dataTarget) {
          // Remove the # from data-target to get the id
          const collapseId = dataTarget.substring(1);
          const collapseElement = document.getElementById(collapseId);

          if (collapseElement && collapseElement.classList.contains("show")) {
            // Use Bootstrap collapse if available
            if (typeof jQuery !== "undefined" && jQuery.fn.collapse) {
              try {
                jQuery(collapseElement).collapse("hide");
                // Update aria-expanded attribute
                header.setAttribute("aria-expanded", "false");
              } catch (e) {
                // Fallback: manually remove show class
                collapseElement.classList.remove("show");
                header.setAttribute("aria-expanded", "false");
              }
            } else {
              // Fallback: manually remove show class
              collapseElement.classList.remove("show");
              header.setAttribute("aria-expanded", "false");
            }
          }
        }
      }
    }
  }
}

// Function to handle mobile redirect
function handleMobileRedirect() {
  const isMobile = isMobileDevice();
  const currentPath = window.location.pathname;
  const currentSearch = window.location.search;

  // Redirect to obras page if on root path (only on initial load)
  if (isMobile && currentPath === "/" && !currentSearch.includes("filtro")) {
    const obrasPath = "/obras?filtro[nuestra_gestion]=1";

    // Only redirect if we're truly on the root path and haven't redirected yet
    if (currentPath === "/" && !sessionStorage.getItem("mobile_redirected")) {
      sessionStorage.setItem("mobile_redirected", "true");
      window.location.href = obrasPath;
      return;
    }
  }

  // Reset the redirect flag when navigating away from root
  if (currentPath !== "/") {
    sessionStorage.removeItem("mobile_redirected");
  }
}

// Execute immediately to close leftbar as soon as possible
(function () {
  // Try to close leftbar immediately if mobile
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      handleMobileLeftbar();
      // Small delay to ensure detect.js has run and DOM is fully ready
      setTimeout(function () {
        handleMobileRedirect();
        handleMobileFilterSection();
      }, 100);
    });
  } else {
    // DOM already loaded
    handleMobileLeftbar();
    setTimeout(function () {
      handleMobileRedirect();
      handleMobileFilterSection();
    }, 100);
  }
})();

// Also handle on turbolinks:load and jQuery ready
$(document).on("ready turbolinks:load", function () {
  handleMobileLeftbar();
  handleMobileRedirect();
  handleMobileFilterSection();
});
